module.exports = __webpack_public_path__ + "static/media/jetblue-favicon.a513982b.ico";